import decode from 'jwt-decode'
import moment from 'moment'

export default (token) => {
	if (!token) return -1
	const { exp } = decode(token)
	return moment(exp * 1000).diff(moment().format()) / 1000 / 60 // minutes
}
